import { render, staticRenderFns } from "./EntregarRopa.vue?vue&type=template&id=708009d2&"
import script from "./EntregarRopa.vue?vue&type=script&lang=js&"
export * from "./EntregarRopa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports